import React from "react";

import { AppShape } from "@eave/shared/types/api";

import BaseTable from "web_modules/shared/BaseTable";

import { makeHeaderData } from "web_modules/shared/BaseTable/helpers";
import formatCurrency from "@eave/borrower/web_modules/utils/formatCurrency";

interface Props {
  app: AppShape;
  expandOverride: boolean;
}

const SubjectPropertyRentalIncomeTable: React.FC<Props> = ({ app, expandOverride }: Props) => {
  const appraised =
    app.subject_property_rental_income?.gross_rental_income_appraised &&
    Number(app.subject_property_rental_income?.gross_rental_income_appraised) !== 0;
  const monthlyNet = app.subject_property_rental_income?.net_rental_income;
  const monthlyGross = app.subject_property_rental_income?.gross_rental_income;

  const { appraisal } = app;
  let unitAppraisals: {
    unit1: number;
    unit2: number;
    unit3: number;
    unit4: number;
  }[] = [];
  if (appraisal) {
    const {
      appraised_market_rent_unit1,
      appraised_market_rent_unit2,
      appraised_market_rent_unit3,
      appraised_market_rent_unit4,
    } = appraisal;
    unitAppraisals = [
      {
        unit1: appraised_market_rent_unit1,
        unit2: appraised_market_rent_unit2,
        unit3: appraised_market_rent_unit3,
        unit4: appraised_market_rent_unit4,
      },
    ];
  }

  return (
    <BaseTable
      useExpandedRows
      headerData={makeHeaderData({
        heading: "Gross",
        monthly_total: "Monthly Amount (net)",
        unit1: "Unit 1",
        unit2: "Unit 2",
        unit3: "Unit 3",
        unit4: "Unit 4",
      })}
      title={`Subject Property Rental Income: (Net ${formatCurrency(monthlyNet, 2, 2)}): 
        ${appraised ? "Appraised" : "Expected"}
        `}
      rawRowData={monthlyNet as any}
      rowData={unitAppraisals.map(i => ({
        ...i,
        heading: `${formatCurrency(monthlyGross, 2, 2)}`,
        unit1: `${appraised ? formatCurrency(i.unit1, 2, 2) : "-"}`,
        unit2: `${appraised ? formatCurrency(i.unit2, 2, 2) : "-"}`,
        unit3: `${appraised ? formatCurrency(i.unit3, 2, 2) : "-"}`,
        unit4: `${appraised ? formatCurrency(i.unit4, 2, 2) : "-"}`,
        monthly_total: `${formatCurrency(monthlyNet, 2, 2)}`,
      }))}
      expandOverride={expandOverride}
      collapseOverride
    />
  );
};

export default SubjectPropertyRentalIncomeTable;
